<template>

     <v-layout row wrap class="">
       <v-flex class="xs12 sm12 md6 lg6 xl6 imgPanel"  >
         <ImagePanel v-if="item !== null" :item="item"></ImagePanel>
       </v-flex>

       <v-flex class="xs12 sm12 md6 lg6 xl6" >
         <v-layout column justify-space-between fill-height class="pa-2">
           <div class="text-xs-left">
             <h3 class="headline mb-0">{{ name }} </h3>
               <div class="subheading" v-html="itemDescription" ></div>
           </div>
           <div class="text-xs-right">
             <span class="subheading accent--text font-weight-bold">Price: {{ itemPriceCurrency }}</span>
             <v-btn class="secondary" :loading=adding @click="addToCart">Add to Cart</v-btn>
             <div align-self-end v-if="errorToShow" class="error--text font-weight-bold">
                 {{ errorToShow }}
             </div>
             <div v-if="showSuccess" class="success--text font-weight-bold">
                 Item added to cart
             </div>
           </div>
         </v-layout>
       </v-flex>

       <!-- Back button -->
       <div class="text-xs-left">
         <v-btn round class="secondary" @click="$router.go(-1)">
           <v-icon left dark>{{$vuetify.icons.back}}</v-icon>
           Back
         </v-btn>
       </div>

     </v-layout>
</template>

<script>
import {mapState} from 'vuex'
import ImagePanel from '../common/ImagePanel.vue'
import utils from '../../utils.ts'

export default {
  name: 'Item',
  components: {
    ImagePanel
  },
  computed: {
    ...mapState({
      item: state => state.shopping.selectedItem
    }),
    thumbnailToShow: function () {
      if (this.item == null) {
        return null
      }

      const thumbs = this.item.thumbnails
      for (let i = 0; i < thumbs.length; i++) {
        if (thumbs[i]) {
          return thumbs[i].thumbDownloadURL
        }
      }
      return null
    },
    itemPriceCurrency: function () {
      if (this.item !== null) {
        return utils.formatCurrency(this.item.price)
      } else {
        return 'Not Loaded'
      }
    },
    itemDescription: function () {
      if (this.item !== null) {
        return this.item.description
      } else {
        return 'No description'
      }
    },
    name: function () {
      if (this.item) {
        return this.item.name
      } else {
        return 'Loading...'
      }
    }
  },
  data () {
    return {
      errorToShow: null,
      adding: false,
      showSuccess: false,
    }
  },
  mounted: function () {
    if (this.item === null) {
      // Go back to the main page
      this.$router.push({name: 'ViewItems'})
    }
  },
  methods: {
    addToCart: function () {
      this.showSuccess = false
      this.adding = true
      this.$store.dispatch('cart/addToCart', this.item).then( () => {
         this.adding = false
         this.showSuccess = true
      }).catch((err) => {
        this.errorToShow = err.message
        this.adding = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.item {
  margin:10px;
  width: 100%;
}

.imgPanel {
  max-height: 100vh;
  height: 100%;
}

</style>
